import { DomainBase } from "./DomainBase";

  export class CategoryMasterClass extends DomainBase {
    constructor() {
        super();
        this.name = '';
        this.otherLanguageName = '';
        this.branch = null;
    }
}
          